import { useState } from 'react';
import { Modal } from 'antd';

const EMPTY_RESULTS = { successList: [], errorList: [] };
const DEFAULT_ERROR_MESSAGE = 'An error occurred during upload.';

const getErrorMessage = ({ response, error }) =>
  response?.error || error?.message || (error && String(error)) || DEFAULT_ERROR_MESSAGE;

export default function useExcelUpload({
  successKey,
  errorKey,
  formatError = item => item
}) {
  const [fileList, setFileList] = useState([]);
  const [results, setResults] = useState(EMPTY_RESULTS);

  const handleChange = info => {
    const { status, response } = info.file;
    setFileList(info.fileList.slice(-1));

    if (status === 'done') {
      setResults({
        successList: response?.[successKey] ?? [],
        errorList: (response?.[errorKey] ?? []).map(formatError)
      });
      return;
    }

    setResults(EMPTY_RESULTS);
    if (status === 'error') {
      Modal.error({ title: 'Upload Failed', content: getErrorMessage(info.file) });
    }
  };

  const hasResults =
    results.successList.length > 0 || results.errorList.length > 0;

  return { fileList, ...results, hasResults, handleChange };
}
